import { render, staticRenderFns } from "./SellCoinsModalProps.vue?vue&type=template&id=630b2070&"
import script from "./SellCoinsModalProps.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsModalProps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports